import styled from 'styled-components';

export const ConnectOTVBStyled = styled.div`
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 450px;
	}
`;

export const CodeEnteredContainerStyled = styled.div`
	gap: 12px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 8px;
	width: 300px;
	text-align: center;
`;
